import { useCreateSource } from 'api/HightouchAPI';
import { ExitModalVariants, PAGE_TITLE } from 'modules/dataWarehouse/constants';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Takeover } from 'ui/workflows/takeover';
import { ExitModal } from './ExitModal';
import { TakeoverBody } from './TakeoverBody';

export const CREATE_SOURCE_TEXT = {
  errorTitle: 'We are having trouble creating a source right now.',
  errorSubtitle: 'Sorry about that! Please try again later.',
  id: 'create-source',
  iframeName: 'createSourceIframe',
  iframeTitle: 'Create data source',
  takeoverTitle: PAGE_TITLE,
};

type CreateSourceTakeoverProps = { sourceType?: string; onClose: () => void };

export const CreateSourceTakeover = ({ onClose, sourceType }: CreateSourceTakeoverProps) => {
  const dispatch = useDispatch();
  const { data, error, isLoading, mutate } = useCreateSource({
    onError: (err) => {
      dispatch(addNegativeToastWithErrorId('Unable to create source.', 'useCreateSource', err));
    },
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    mutate({
      sourceType,
    });
  }, []);

  return (
    <>
      <Takeover
        Body={
          <TakeoverBody
            errorSubtitle={CREATE_SOURCE_TEXT.errorSubtitle}
            errorTitle={CREATE_SOURCE_TEXT.errorTitle}
            hasError={!!error}
            id={CREATE_SOURCE_TEXT.id}
            name={CREATE_SOURCE_TEXT.iframeName}
            title={CREATE_SOURCE_TEXT.iframeTitle}
            url={data?.url}
          />
        }
        isLoading={isLoading}
        isMainApp
        isOverlay
        noPadding
        onClose={() => (error ? onClose() : setShowModal(true))}
        size="100%"
        title={CREATE_SOURCE_TEXT.takeoverTitle}
      />
      {showModal && (
        <ExitModal
          handleCancel={() => setShowModal(false)}
          handleConfirm={onClose}
          variant={ExitModalVariants.CREATE_SOURCE}
        />
      )}
    </>
  );
};
